import React, { useState } from 'react'
import { Circles } from 'react-loader-spinner'
import { useNavigate } from 'react-router-dom'
import { loginDB } from '../Logic/index01'
import {Oval} from 'react-loader-spinner';
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';
import towing from '../assets/mechanic.png'
import mechanic from '../assets/towing.png'
import { messageDisplay } from './Util';
import iconlogo from '../assets/iconLogo2.png'
import  {keyframes} from "styled-components";
import {styled} from "styled-components";




const Login = () =>{


  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [isLoading, setisLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  


 const fadeUp = keyframes`
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
    `;


    const signup = () => {
      up()
      navigate("/signup")
    }

  

   const up = () => {
     window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' 
    });
  }



  const togglePassword = () => {
    setShowPassword(!showPassword);
  };





 const login = async () => {
      setisLoading(true)
         let res = await loginDB({"el":email,"ps":password});
          if(res != undefined){
              if(res.toString().includes("Bad")){
                setisLoading(false)
                  alert(res)   
              }else{
                setisLoading(false)
                  localStorage.setItem(process.env.REACT_APP_LS ,res);
                  navigate("/console");
              }
          }else{
            messageDisplay("Network failure",1);
        }
  }




  return (
    <>
       <div class="relative flex h-auto min-h-screen w-full flex-col bg-white  group/design-root overflow-x-hidden">
                 <div class="flex flex-1 justify-center">
                  <div class="layout-content-container flex flex-col w-full flex-1">
                    <div class="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
                     <div className="relative hidden lg:flex flex-col items-center justify-center bg-[#060d1a]/90  p-12">

                      <div class="absolute flex items-center gap-3">
                    
                          <Carousel infiniteLoop={true} autoPlay={true}  showThumbs={false}>
                            <div>
                                <img src={mechanic} className='w-full h-full' />
                            </div>
                            <div>
                                <img src={towing} className='w-full h-full'/>
                          </div>
                        </Carousel>
                      </div>
                      <div class="w-full max-w-md">
                      <div class="w-full bg-center bg-no-repeat bg-cover aspect-square rounded-none" ></div>
                      </div>
                      <p class="mt-8 max-w-md text-center text-xl font-medium text-white">Unified tracking solution.</p>
                    </div>



                    <div className="flex flex-col items-center justify-center bg-white p-6 sm:p-12">
                    <div class="w-full max-w-md">
                    <div  class="flex flex-col gap-3 mb-4">

                      <div class="rounded-lg flex items-center self-center mb-12">
                          <img src={iconlogo}  />
                      </div>

                      <p  class="text-text-primary text-4xl font-black leading-tight tracking-[-0.033em]">Sign In</p>
                      <p class="text-brand-medium-gray1 dark:text-gray-400 text-base font-normal leading-normal">Welcome back! Please enter your details.</p>
                      </div>
                      <div class="flex flex-col gap-6">
                      <label class="flex flex-col min-w-40 flex-1">
                      <p class="text-brand-dark-blue1 dark:text-gray-400 text-base font-medium leading-normal pb-2">Email</p>
                      <input  value={email}   onChange={(e) => setEmail(e.target.value)}   class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-brand-dark-blue1 dark:text-grey focus:outline-0 focus:ring-2 focus:ring-brand-bright-blue1/50 border border-[#dbe2e6] dark:border-gray-700 bg-white focus:border-brand-bright-blue h-14 placeholder:text-brand-medium-gray p-[15px] text-base font-normal leading-normal" placeholder="you@example.com"/>
                      </label>
                      <label class="flex flex-col min-w-40 flex-1">
                      <p class="text-brand-dark-blue dark:text-gray-400 text-base font-medium leading-normal pb-2">Password</p>
                      <div class="flex w-full flex-1 items-stretch rounded-lg">
                      <input   value={password}  type={showPassword ? 'text' : 'password'}  onChange={(e) => setPassword(e.target.value)}   class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-l-lg text-brand-dark-blue1 dark:text-grey focus:outline-0 focus:ring-2 focus:ring-brand-bright-blue1/50 border border-[#dbe2e6] dark:border-gray-700 bg-white focus:border-brand-bright-blue h-14 placeholder:text-brand-medium-gray p-[15px] pr-2 text-base font-normal leading-normal border-r-0" placeholder="Enter your password"/>
                      <div onClick={togglePassword} class="text-brand-medium-gray1 dark:text-gray-400 flex border border-[#dbe2e6] dark:border-gray-700 bg-white dark:bg-background-dark1/50 items-center justify-center pr-[15px] rounded-r-lg border-l-0">
                      {!showPassword ? <span class="material-symbols-outlined cursor-pointer">visibility</span>:  <span class="material-symbols-outlined cursor-pointer">visibility_off</span>}
                      </div>
                      </div>
                      </label>
                      </div>
                      <div class="flex justify-end mt-4" onClick={(e) => navigate("/forgot")}>
                      <p class="text-brand-medium-gray dark:text-gray-400 text-sm font-normal leading-normal underline cursor-pointer hover:text-brand-bright-blue1">Forgot Password?</p>
                      </div>
                      <div class="mt-8 flex flex-col gap-4">
                        
                      <button disabled={isLoading ? true :false} onClick={email.trim().length > 0 && password.trim().length > 0  ? login : null} class="flex items-center justify-center rounded-lg h-14 px-6 text-base font-semibold bg-blue-500  text-white bg-brand-bright-blue hover:bg-opacity-90 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-bright-blue ">
                              {isLoading ? <Oval strokeWidth={3} width={30} height={30} color='blue'/> 
                                  :
                              "Sign In"}
                          </button>
                      </div>
                      <div class="mt-8 text-center h-12">
                        <p class="text-brand-medium-gray dark:text-gray-400 text-sm">
                              Don't have an account? 
                              <a class="font-semibold text-brand-bright-blue hover:underline" onClick={signup}> Register here</a>
                        </p>
                      </div>
                      </div>
                      <div class="absolute bottom-6 text-center text-xs text-brand-medium-gray dark:text-gray-500">
                      <a class="hover:underline" href="#">Terms of Service</a> • <a class="hover:underline" href="#">Privacy Policy</a>
                      </div>
                     </div>
                    </div>
                  </div>
                </div>
         </div>
    </> 
  )
}

export default Login
